import _ from 'lodash';

function stitchPpi(ppi) {
  const prepAndProdSteps = _.get(ppi, 'prepAndProdSteps', []).map(step => {
    return {
      ...step,
      ...step.stepDetails[0]
    };
  });
  const { itemCode } = ppi.referencedIngredientData;
  return {
    ...ppi,
    itemCode,
    prepAndProdSteps
  };
}

function stitchPpis(ppis) {
  return ppis.map(stitchPpi);
}

export { stitchPpi, stitchPpis };
